import { motion } from "framer-motion";

// Note: id="glosario" is added to the section for navigation
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const glossaryTerms = [
  {
    term: "Brand Equity",
    definition:
      "El valor comercial que se deriva del reconocimiento y percepción de tu marca en el mercado. Es lo que hace que tu empresa valga más que la suma de sus activos tangibles.",
  },
  {
    term: "Premium Price",
    definition:
      "La capacidad de cobrar un precio superior al promedio del mercado gracias a la percepción de valor diferenciado de tu marca. Es el margen adicional que pagan los clientes por elegirte a vos y no a tu competencia.",
  },
  {
    term: "Lealtad Patrimonial",
    definition:
      "El nivel de compromiso de tus clientes que trasciende el factor precio. Cuando la lealtad es patrimonial, los clientes permanecen con vos porque valoran la relación y la confianza construida, no solo el producto o servicio.",
  },
  {
    term: "Identidad Propietaria",
    definition:
      "Los elementos visuales, comunicacionales y experienciales que son exclusivamente reconocibles como tuyos. Una identidad propietaria te hace inconfundible incluso sin tu logo.",
  },
  {
    term: "Velocidad de Capitalización",
    definition:
      "La rapidez con la que un potencial inversor, socio o cliente puede comprender el valor diferencial de tu compañía. A mayor velocidad, mayor eficiencia en cerrar negocios y atraer capital.",
  },
  {
    term: "Multiplicador de Valor",
    definition:
      "El factor por el cual se multiplica el valor de tus activos tangibles gracias a tu marca. Una empresa con alto multiplicador vale significativamente más que la suma de sus máquinas, inventarios y propiedades.",
  },
  {
    term: "Brand Extension",
    definition:
      "La capacidad de tu marca para transferir su valor a nuevas líneas de negocio o productos. Una marca fuerte hace que cualquier extensión sea rentable desde el día uno.",
  },
  {
    term: "Riesgo de Devaluación",
    definition:
      "El peligro de que tu marca pierda valor por depender de promociones, descuentos o estrategias de corto plazo que erosionan la percepción de exclusividad y calidad.",
  },
];

const Glossary = () => {
  return (
    <section id="glosario" className="py-20 md:py-28 bg-card">
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-12"
        >
          <span className="text-primary text-sm font-semibold tracking-widest uppercase mb-4 block">
            Glosario
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
            Conceptos Clave del{" "}
            <span className="text-gradient-gold">Capital de Marca</span>
          </h2>
          <p className="text-muted-foreground">
            Entendé los términos que definen el valor real de tu trayectoria empresarial.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {glossaryTerms.map((item, index) => (
              <motion.div
                key={item.term}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <AccordionItem
                  value={item.term}
                  className="bg-background border border-border rounded-xl px-6 data-[state=open]:shadow-lg transition-shadow"
                >
                  <AccordionTrigger className="text-left font-display text-lg font-semibold text-[#470628] hover:text-primary transition-colors">
                    {item.term}
                  </AccordionTrigger>
                  <AccordionContent className="text-black leading-relaxed pb-4">
                    {item.definition}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default Glossary;
